import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import Collection from "@arcgis/core/core/Collection";
import { AppConfig } from "../../../app.config";
import Extent from "@arcgis/core/geometry/Extent";
let BookmarkComponent = class BookmarkComponent {
    constructor() { }
    addBookmarks() {
        const bookmarksCollection = new Collection();
        AppConfig.settings.bookmarks.forEach(bookmark => {
            bookmarksCollection.add({
                name: bookmark.name,
                viewpoint: {
                    targetGeometry: new Extent(bookmark.viewpoint.targetGeometry)
                },
                thumbnail: bookmark.thumbnail
            });
        });
        return bookmarksCollection;
    }
    static ctorParameters = () => [];
};
BookmarkComponent = __decorate([
    Injectable({
        providedIn: "root"
    })
], BookmarkComponent);
export { BookmarkComponent };
